/**
 * Sprint 006b (P3-Kanon) — Die eine Save-Bar für alle Formulare.
 *
 * Extrahiert aus der byte-identischen Sticky-Bar in InvoiceForm /
 * CustomerForm / ExpenseForm (Sprint-006 M2): klebt mobil über der
 * BottomNav (gemessene Höhe plus Abstand), ist ab lg statisch. Buttons kommen als children
 * (Abbrechen / Speichern / Sekundär-Aktionen), damit jede Form ihre
 * eigene Button-Logik behält — nur der Container ist Kanon.
 */
import { type ReactNode } from 'react';

interface FormSaveBarProps {
  children: ReactNode;
  className?: string;
}

export function FormSaveBar({ children, className = '' }: FormSaveBarProps) {
  return (
    <div
      className={`flex flex-wrap justify-end gap-3 sticky bottom-[calc(var(--mobile-nav-height,80px)+8px)] lg:static lg:bottom-auto z-20 -mx-3 px-3 py-3 lg:m-0 lg:p-0 bg-zinc-950/90 backdrop-blur-md border-t border-white/10 lg:bg-transparent lg:backdrop-blur-none lg:border-0 rounded-lg lg:rounded-none ${className}`}
    >
      {children}
    </div>
  );
}

export default FormSaveBar;
